import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Tooltip from 'material-ui/Tooltip';
import IconButton from 'material-ui/IconButton';
import Brightness4 from '@material-ui/icons/Brightness4';
import Brightness7 from '@material-ui/icons/Brightness7';
import Menu, { MenuItem } from 'material-ui/Menu';
import RemoveRedEye from '@material-ui/icons/RemoveRedEye';
import ShortText from '@material-ui/icons/ShortText';
import FormatAlignLeft from '@material-ui/icons/FormatAlignLeft';
import { ListItemIcon, ListItemText } from 'material-ui/List';
import * as CalendarState from '../../state/reducer/calendar/calendar';

const FullScreenHeader = ({ session, theme, onToggleTheme }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const calendarInstructionsEnabled = useSelector(
        state => state.calendar.uiTree.calendarInstructionsEnabled
    );
    const calendarBlockNamesEnabled = useSelector(
        state => state.calendar.uiTree.calendarBlockNamesEnabled
    );

    const handleViewOptionsOpen = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleViewOptionsClose = () => {
        setAnchorEl(null);
    };

    const toggleInstructions = () => {
        CalendarState.toggleCalendarInstructions();
        handleViewOptionsClose();
    };

    const toggleBlockNames = () => {
        CalendarState.toggleCalendarBlockNames();
        handleViewOptionsClose();
    };

    return (
        <div className="fullscreen-header">
            <div className="fullscreen-header-left">
                <img
                    className="fullscreen-header-th-logo"
                    alt="TrainHeroic"
                    src="https://static.trainheroic.com/images/h_white.png"
                />
            </div>
            <div className="fullscreen-header-center">
                {session &&
                    session.title && (
                        <span className="fullscreen-header-title">
                            {session.title}
                        </span>
                    )}
            </div>
            <div className="fullscreen-header-right">
                <button
                    className="fullscreen-theme-toggle"
                    onClick={onToggleTheme}
                    aria-label={`Switch to ${
                        theme === 'dark' ? 'light' : 'dark'
                    } mode`}
                >
                    {theme === 'dark' ? <Brightness7 /> : <Brightness4 />}
                </button>
                <Tooltip title="View Options">
                    <IconButton color="inherit" onClick={handleViewOptionsOpen}>
                        <RemoveRedEye />
                    </IconButton>
                </Tooltip>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleViewOptionsClose}
                    className="th-menu"
                >
                    <MenuItem onClick={toggleInstructions}>
                        <ListItemIcon>
                            <ShortText />
                        </ListItemIcon>
                        <ListItemText
                            inset
                            primary={
                                calendarInstructionsEnabled
                                    ? 'Hide Instructions'
                                    : 'Show Instructions'
                            }
                        />
                    </MenuItem>
                    <MenuItem onClick={toggleBlockNames}>
                        <ListItemIcon>
                            <FormatAlignLeft />
                        </ListItemIcon>
                        <ListItemText
                            inset
                            primary={
                                calendarBlockNamesEnabled
                                    ? 'Hide Block Titles'
                                    : 'Show Block Titles'
                            }
                        />
                    </MenuItem>
                </Menu>
            </div>
        </div>
    );
};

export default FullScreenHeader;
